import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "../../../components";
import CircularIndeterminate from "../../../components/circleLoader/CircleLoader";
import { AppRoutes, LocalStorageItems } from "../../../constants";
import useAuth from "../../../hooks/useAuth";
import { ForgotPasswordModal } from "../../../modals";
import { getMeUser, login } from "../../../Services_V2/Auth.service";
import { ROLE_REDIRECT_MAP, UserRole } from "../../../types";
import { showError } from "../../../utils/error";
import { ILoginInputs, LoginInputs, loginSchema } from "./const";
import styles from "./organization-login.module.css";

const OrganizationLogin = () => {
  const navigation = useNavigate();
  // const { dispatch } = useOrganization();
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isOpenForgotPw, setIsOpenForgotPw] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = useCallback(async (values: ILoginInputs) => {
    setLoading(true);
    try {
      const response = await login(values);
      const token = response.data.token;
      localStorage.setItem(LocalStorageItems.TOKEN, token);
      const userRes = await getMeUser();
      dispatch({
        type: "updateState",
        payload: {
          user: userRes?.user,
          userOrganization: userRes?.entityDetails,
        },
      });
      const redirectRoute =
        ROLE_REDIRECT_MAP[userRes?.user?.role as UserRole] ??
        AppRoutes.ORGANIZATION.LOGIN;
      setLoading(false);

      navigation(redirectRoute);
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <div className={styles.container}>
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.header}>
            <p className={styles.logo}>Login</p>
            <p className={styles.description}>
              Please use your credentials to login
            </p>
          </div>
          <div className={styles.formControls}>
            <Input
              fullWidth
              label="Email"
              placeholder="Enter your email"
              {...register(LoginInputs.EMAIL)}
              error={!!errors[LoginInputs.EMAIL]}
              helperText={errors[LoginInputs.EMAIL]?.message}
            />
            <Input
              fullWidth
              label="Password"
              type="password"
              placeholder="Enter your password"
              {...register(LoginInputs.PASSWORD)}
              error={!!errors[LoginInputs.PASSWORD]}
              helperText={errors[LoginInputs.PASSWORD]?.message}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
            startIcon={loading ? <CircularIndeterminate size={20} /> : null}
          >
            Login
          </Button>
          <Box className="flex-box">
            <Button
              variant="text"
              sx={{ mt: 1 }}
              onClick={() => setIsOpenForgotPw(true)}
            >
              Change or Forgot password?
            </Button>
          </Box>
        </form>
      </div>
      <ForgotPasswordModal
        open={isOpenForgotPw}
        onClose={() => setIsOpenForgotPw(false)}
      />
    </>
  );
};

export default OrganizationLogin;
